import React, { ReactNode } from "react";
import ReactDOM from "react-dom/client";

import reportWebVitals from "./reportWebVitals";

import "bootstrap/dist/css/bootstrap.min.css";
import App from "./components/app";

import "./index.scss";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import ErrorBoundary from "./components/errorBoundary";
import AuthInterceptor from "./utils/auth.interceptor.js";
import ProductAnalyticWrapper from "./components/ProductAnalyticWrapper";
import { TourWrapper } from "./components/tour/tour.wrapper";


AuthInterceptor();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(

  <Provider store={store}>
    <ProductAnalyticWrapper>
      <ErrorBoundary>
      <TourWrapper>
        <App />
      </TourWrapper>
      </ErrorBoundary>
    </ProductAnalyticWrapper>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();